import { chartSpacing, addSpaceForAnnotations } from './spacing';
import * as chart from './chart';
import * as legend from './legend';
import * as tooltips from './tooltips';
import * as axes from './axes';
import * as recessions from './recessions';
import * as defs from './defs';
import * as annotationsPre from './annotations-prerender';
import * as annotationsPost from './annotations-postrender';
import * as plotLines from './plotLines-postrender';
/**
 * The Inner Chart renders the actual chart sans headlines or footnotes.
 */
export function preRender(options) {
  // const hasAccessibility = options.headings.accessibilityDescription.text;
  // const  defaultDescription = hasAccessibility ? hasAccessibility : options.headings.subdek.text || options.headings.title.text;
  const isVideo = options.id === 'video' || options.id ==='twitterVideo';

  let data = {
    exporting: {
      enabled: false,
    },
    // accessibility: {
    //   description: defaultDescription
    // },
    series: options.series,
    chart: {
      reflow: false,
      type: options.type,
      width: options.width,
      height: options.height,
      style: isVideo ? JSON.stringify(options.styles.base):options.styles.base,
      renderTo: options.el.querySelector('.dj-chart-inner'),
      backgroundColor: 'transparent',
      panning: false,
      // backgroundColor: 'rgba(255, 0, 0, 0.1)'
    },
    credits: { enabled: false },
    title: { text: null },
    legend: { enabled: false },
    annotations: [],
    defs: {},
    plotOptions: {},
    xAxis: {},
    yAxis: {}
  };
  if (options.irregularDates) {
    data.scrollbar = { enabled: false };
    data.rangeSelector = { enabled: false };
    data.navigator = { enabled: false };
  }
  data.chart.spacing = chartSpacing(options);
  const isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
  // only invoke addSpaceForAnnotations for charts that can't be found in isSmallMW variable
  // if (!isSmallMW) {
  //   data.chart.spacing = addSpaceForAnnotations(data.chart.spacing, options);
  // }
  
  data.plotOptions[options.type] = {};
  data = chart.preRender(data, options);
  const isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
  if (isZR || options.size.indexOf('thumb') === 0) {
    data.plotOptions.series = data.plotOptions.series || {};
    data.plotOptions.series.enableMouseTracking = false;
    data.xAxis.labels = data.xAxis.labels || {};
    data.yAxis.labels = data.yAxis.labels || {};
    data.yAxis.labels.enabled = false;
    if (isZR) data.xAxis.labels.enabled = false;
    data.xAxis.tickWidth = 0;
    data.yAxis.title = data.yAxis.title || {};
    data.yAxis.title.text = '';
    data.yAxis.gridLineWidth = data.xAxis.gridLineWidth = 0;
    data.xAxis.lineWidth = 0;
    data.chart.spacingTop = 0;
  } else {
    data = legend.preRender(data, options);
    data = tooltips.preRender(data, options);
    data = axes.preRender(data, options);
    data = recessions.preRender(data, options);
    if (options.annotations.length) {
      defs.preRender(data, options);
      annotationsPre.preRender(data, options);
    }
  }
  if (options.size === 'marketwatch-ZT') {
    data.xAxis.labels.enabled = false;
    data.chart.spacingBottom = 20;
  }
  if (options.irregularDates) {
    data.xAxis.crosshair = { width: 0 };
    data.yAxis.showLastLabel = true;
  }
  return data;
}

export function postRender(highchart, options) {
  chart.postRender(highchart, options);
  const isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
  if (options.size.indexOf('thumb') === 0 || isZR || options.size === 'marketwatch-ZT') {
    if (__MARKETWATCH__) {
      if (options.type !== 'bar') {
        // unclear what this did
        let topEl = options.el.lastChild.lastChild.lastChild.lastChild;
        let firstChildThumb = topEl.firstChild;
        let secondChildThumb = topEl.lastChild;
        // firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
        // firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
      }
    }
  } else {
    // if (options.type !== 'scatter') {
      legend.postRender(highchart, options);
    // }
    
    tooltips.postRender(highchart, options);
    axes.postRender(highchart, options);
    recessions.postRender(highchart, options);
    if(options.plotLines[0].plotLineValue) plotLines.postRender(highchart, options);
    if (options.type !== 'pie' && options.type !== 'bar' && options.annotations.length) {
      annotationsPost.postRender(highchart, options);
    }
  }
}

export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    chart.renderInvalidated(rendered, options, invalidated);
  }
}


// WEBPACK FOOTER //
// ./src/chart/inner/index.js